import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  DownloadReportComponent,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import { ResolvedColumns } from '@principle-theorem/reporting';
import { ITimePeriod, filterUndefined } from '@principle-theorem/shared';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReportBuilderStore } from '../report-builder.store';
import { ReportBuilderCSV } from './report-builder-csv';
import { ReportBuilderTableComponent } from './report-builder-table/report-builder-table.component';

@Component({
  selector: 'pr-report-builder-results-table',
  templateUrl: './report-builder-results-table.component.html',
  styleUrls: ['./report-builder-results-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgCommonModule,
    MatButton,
    DownloadReportComponent,
    ReportBuilderTableComponent,
  ],
})
export class ReportBuilderResultsTableComponent {
  csvData$: Observable<object[]>;
  csvTranslator$: Observable<ReportBuilderCSV>;
  dateRange$: Observable<ITimePeriod>;

  constructor(public store: ReportBuilderStore) {
    this.csvData$ = this.store.results$.pipe(
      map((results) => results?.filtered ?? [])
    );
    this.csvTranslator$ = combineLatest([
      this.store.dataSource$.pipe(filterUndefined()),
      this.store.display$,
      this.store.currentReport$.pipe(map((report) => report?.name)),
    ]).pipe(
      map(
        ([dataSource, display, reportName]) =>
          new ReportBuilderCSV(
            ResolvedColumns.toColumns(dataSource, display?.columns ?? []),
            reportName
          )
      )
    );
  }
}
